export default __webpack_public_path__ + "static/media/elmer702.547d8f2b.jpg";